import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Checkbox, TableSortLabel, Tooltip, Grid, Box, Typography, } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import OpeningBalanceCRU from './OpeningBalanceCRU';
import OpeningBalanceList from './OpeningBalanceList';
import {  openingBalanceObj,} from '../components';
import "../styles/reserverate.scss"
import { deleteOpeningBalanceApi, getOpeningBalanceApi } from '../apiService';
import { checkApiStatus } from '../../../utils';
import { PageLoader, Pagination, STableLoader, NoRecordFound } from '../../../shared_elements';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { ShowAttachments, DeletePopUp, ButtonLoader,  } from '../../../shared_elements/components';
import { PermissionWrapper } from '../../../wrappers';
import { RoleBaseAccess } from '../../../hoc';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import { getStorage } from '../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { trackActivity } from '../../../utils/mixpanel';
import BackToLeaseList from '../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 235px)';

const OpeningBalanceHD = ({ toggleBulkOps, tableSorting, item, bulk, leaseBasicDetails}) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['D'] }}>
                        {leaseBasicDetails?.is_reserve_rate === 0 ? 
                        <Tooltip title="Select All" arrow placement='top'>
                            <Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} /></Tooltip> : null }
                    </PermissionWrapper>
                    <span >Action(s)</span></TableCell>
                <TableCell sx={{ minWidth: "200px" }}> {tableSorting('major_assembly', 'Major Assembly')}  </TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('mainteance_program_id', 'Event')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('amount', 'Fund')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('fund_balance_as_of', 'Fund Date')}</TableCell>
                <TableCell sx={{ minWidth: "200px" }}>Remarks</TableCell>
            </TableRow>
        </TableHead>
    );
};

const OpeningBalance = () => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { enqueueSnackbar } = useSnackbar();
    const { leaseBasicDetails ,fileUploadDetails} = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false)
    const [openingBalanceInfo, setOpeningBalanceInfo] = useState({ list: [], pagination: { page: 1, per_page: 50 } });
    const[isExport,seIsExport]=useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [addEditOpeningBalance, setAddEditOpeningBalance] = useState({ mode: '', modal: false, data: openingBalanceObj })
    const [deleteOpeningBalance, setDeleteOpeningBalance] = useState({ modal: false, data: null });
    const [queryConfig, setQueryConfig] = useState({
        page: openingBalanceInfo?.pagination?.page || 1,
        per_page: openingBalanceInfo?.pagination?.per_page || 50,
    });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})

    const getOpeningBalanceList = (query, type) => {
        if (type === "initial") {
            setSkeletonLoader(true)
        } else {
            setLoading(true)
        }
        globalGetService(getOpeningBalanceApi(params, query))
            .then(response => {
                setSkeletonLoader(false);
                setLoading(false)
                if (checkApiStatus(response)) {
                    setOpeningBalanceInfo(response?.data?.data)
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                }
            });
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"eol_obligation"}))
    };

    useEffect(() => {
         const uploadedFileData = getApiResponse("opening_balance", slug);
        getOpeningBalanceList(queryConfig, "initial");
         setUploadFileProgressData({uploadedFileData});
        trackActivity('Page Viewed', { page_title: 'Opening Balance' })
    }, []);
    const createSortHandler = (key) => {
        const isAsc = queryConfig.sort_by === key && queryConfig.sort === 'asc';
        const updatedSort = isAsc ? 'desc' : 'asc';
        setQueryConfig({
            page: openingBalanceInfo?.pagination?.page || 1,
            per_page: openingBalanceInfo?.pagination?.per_page || 20,
            sort_by: key,
            sort: updatedSort
        });
        getOpeningBalanceList({
            page: openingBalanceInfo?.pagination?.page || 1,
            per_page: openingBalanceInfo?.pagination?.per_page || 20,
            sort: updatedSort,
            sort_by: key,
        }, "");
    };

    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={queryConfig.sort_by === key}
                direction={queryConfig.sort_by === key ? queryConfig.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }

    const onDeleteOpeningBalance = () => {
        setLoading(true)
        globalDeleteService(deleteOpeningBalanceApi(params),
            { ids: (bulk?.type === 'bulk' || bulk?.type === 'single') && bulk.modal ? bulk?.ids?.map(item => item?.id) : [deleteOpeningBalance?.data?.id] }
        ).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Opening Balance`, success_msg: response?.data?.message, item_ids: deleteOpeningBalance?.data || bulk?.ids, response: response?.data })
                setDeleteOpeningBalance({ modal: false, data: null });
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                getOpeningBalanceList(queryConfig, "");
            }
        });
    };

    const toggleBulkOps = async (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else { setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) }) }
    }
    const onDeleteAttachments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditOpeningBalance?.modal) {
            setAddEditOpeningBalance({
                ...addEditOpeningBalance,
                data: {
                    ...addEditOpeningBalance.data,
                    attachments: addEditOpeningBalance.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getOpeningBalanceList(queryConfig, "");
    }

    const handleExport = () => {
        let query = { export: true }
        if (queryConfig?.sort && queryConfig?.sort_by) {
            query = {
                ...query,
                sort: queryConfig?.sort,
                sort_by: queryConfig?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getOpeningBalanceApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

  
    const handleUpload = async (slug,mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "opening_balance",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                 getOpeningBalanceList(queryConfig, "initial");;
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Opening Balance`, page_type: page_type, })
    }
    return (
        <>
            <Paper>
                    <div>
                    <Grid container spacing={1} alignItems='flex-end' style={{ display: "flex", justifyContent: "end" }}>
                        <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                        </Grid>
                        <Grid item size={{ md: 8, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items' style={{ float: 'right', padding: '0px' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => {setBulk({ ...bulk, title: 'Delete', modal: true });handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {openingBalanceInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button>  </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['C'] }}>
                                       <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditOpeningBalance({ modal: true, data: openingBalanceObj, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Opening Balance</Button> </li> 
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </div>
                    <Paper className='lease-detail-table table-tab-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: openingBalanceInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0, boxSizing: 'border-box' }}>
                            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                                <Table className="mui-table-format" stickyHeader >
                                    <OpeningBalanceHD tableSorting={tableSorting} queryConfig={queryConfig} item={openingBalanceInfo?.list} bulk={bulk} toggleBulkOps={toggleBulkOps} leaseBasicDetails={leaseBasicDetails} />
                                    <TableBody>
                                        {openingBalanceInfo?.list?.length > 0 && (
                                            openingBalanceInfo?.list?.map((item, index) => {
                                                 const uploadedFileData = getApiResponse("opening_balance", item?.slug);
                                                return (
                                                    <OpeningBalanceList
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData }
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        key={index}
                                                        leaseBasicDetails={leaseBasicDetails}
                                                        item={item}
                                                        bulk={bulk}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                        deleteOpeningBalance={deleteOpeningBalance}
                                                        toggleBulkOps={toggleBulkOps}
                                                        onEdit={() => { setAddEditOpeningBalance({ modal: true, mode: 'edit', data: item, }) }}
                                                        onDelete={() => setDeleteOpeningBalance({ modal: true, data: item })}
                                                        onView={() => { setAddEditOpeningBalance({ modal: true, mode: 'view', data: item, }) }}
                                                    />
                                                );
                                            })
                                        )}
                                    </TableBody>
                                </Table>
                            )}
                        </div>
                        {skeletonLoader ? null : (
                            <Paper square>
                                {!skeletonLoader && !openingBalanceInfo?.list?.length && <NoRecordFound/>}
                                <Pagination
                                    pagination={openingBalanceInfo?.pagination}
                                    onPageChange={(event, newPage) => getOpeningBalanceList({ ...queryConfig, page: newPage + 1, per_page: openingBalanceInfo?.pagination?.per_page }, 'pageLoader')}
                                    onRowsPerPageChange={(e) => getOpeningBalanceList({ ...queryConfig, page: 1, per_page: e.target.value }, 'pageLoader')}
                                />
                            </Paper>
                        )}
                    </Paper>
            </Paper>
            {uploadfileList?.modal ?
                <ShowAttachments
                    url='delete-attachment'
                    moduleName="Opening Balance"
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeleteAttachments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode:'' })}
                    onViewDisabled={addEditOpeningBalance?.mode === 'view' || uploadfileList?.mode==='view'}
                    permissionKey='reserve_rates'
                /> : null
            }
            {addEditOpeningBalance?.modal ?
                <OpeningBalanceCRU
                   fileUpload={handleUpload}
                    params={params}
                    modeType={addEditOpeningBalance?.mode}
                    addEditOpeningBalance={addEditOpeningBalance}
                    getResponseBack={() => {getOpeningBalanceList(queryConfig, ""); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditOpeningBalance({ modal: false, mode: '', data: openingBalanceObj })}
                    onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditOpeningBalance?.data, mode:'view' })}
                /> : null
            }

            {deleteOpeningBalance?.modal ?
                <DeletePopUp
                    modal={deleteOpeningBalance.modal}
                    title="Delete Opening Balance"
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteOpeningBalance({ modal: false, data: null })}
                    onDeleteRecords={onDeleteOpeningBalance}
                /> : null
            }
            {bulk?.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title="Delete All Opening Balance"
                    onDeleteRecords={onDeleteOpeningBalance}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [] })}
                /> : null
            }
            {
               revisionHistory.modal &&  
               <RevisionHistory 
               moduleName={"opening_balance"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
            }
            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
              progressRefs={uploadFileProgressData?.progressRefs}
              attachments={uploadFileProgressData?.attachments}
              onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(OpeningBalance, { application: 'lease_revamp', feature: 'reserve_rates', operationType: ['R'] });
